import Axios from "axios";
import {
    SET_PURCHASE_RETURN_LIST,
    UNSET_PURCHASE_RETURN_LIST,
    SET_PURCHASE_RETURN_DETAILS,
    UNSET_PURCHASE_RETURN_DETAILS,
} from "@/store/mutation-types";
import { 
    purchaseReturn as purchaseReturnApi, 
    purchaseReturnRecord as purchaseReturnRecordApi, 
    purchaseReturnDetails as purchaseReturnDetailsApi,  
} from "@/store/api";
// initial state

const state = {
  purchaseReturnRecord: [],
  purchaseReturnDetails:[],
  editingPurchaseReturn: null,
};

const getters = {
  purchaseReturnRecord(state) {
    return state.purchaseReturnRecord;
  },
  purchaseReturnDetails(state) { 
    return state.purchaseReturnDetails;
  },
};

const mutations = {
  [SET_PURCHASE_RETURN_LIST](state, data) {
    state.purchaseReturnRecord = data;
  },
  [UNSET_PURCHASE_RETURN_LIST](state) {
    state.purchaseReturnRecord = [];
  },
  [SET_PURCHASE_RETURN_DETAILS](state, data) {
    state.purchaseReturnDetails = data;
  },
  [UNSET_PURCHASE_RETURN_DETAILS](state) {
    state.purchaseReturnDetails = [];
  },
  editingPurchaseReturn(state, purchase_return) {
    state.editingPurchaseReturn = purchase_return;
  },
};

const actions = {
    saveUpdatePurchaseReturn({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
        Axios.post(purchaseReturnApi, data)
            .then(function (response) {
            resolve(response);
            })
            .catch(function (error) {

            reject(error);
            })
            .then((always) => {
                commit("UNSET_LOADING");
            });
        });
    },

    purchaseReturnRecord({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`${purchaseReturnRecordApi}`, { params: data })
            .then(function (response) {
                commit('SET_PURCHASE_RETURN_LIST', response.data.data);
                resolve(response);
            })
            .catch(function (error) {
                commit('UNSET_PURCHASE_RETURN_LIST');
                reject(error);
            })
            .then(() => {
                
            })
        })
    },

    purchaseReturnDetails({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`${purchaseReturnDetailsApi}`, { params: data })
            .then(function (response) {
                commit('SET_PURCHASE_RETURN_DETAILS', response.data.data);
                resolve(response);
            })
            .catch(function (error) {
                commit('UNSET_PURCHASE_RETURN_DETAILS');
                reject(error);
            })
            .then(() => {
                
            })
        })
    },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
